import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/blog/ArticleHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/blog/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/blog/RelatedArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/components/ArticleContent.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/components/BlogArticlePage.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/components/ArticleCategoryChip.css");
